/**
 * services
 */
import { ILayoutLang, LayoutLang } from '@core/services';

/**
 * CLDR locale backing each UI language, for every `Intl` formatter in the app.
 *
 * @remarks
 * Shared rather than declared per formatter because three call sites have to agree on it —
 * `LocalizedNumberPipe`, `LocalizedCurrencyPipe` and the energy-source chart's caption
 * formatter — and they render numbers side by side. A drifting locale between them is exactly
 * the mismatch this const exists to prevent: `ar-SA` groups with `٬` (U+066C) and separates
 * decimals with `٫` (U+066B), so a formatter left on `en-US` prints Arabic digits on Latin
 * separators next to one that does not.
 *
 * These are `Intl` locale ids, not Angular ones — nothing here needs `registerLocaleData`,
 * and the language is looked up per emission of `LangService.changeLang$` rather than bound
 * once at bootstrap the way `LOCALE_ID` is.
 */
export const INTL_LOCALES: Record<ILayoutLang, string> = {
  [LayoutLang.Ar]: 'ar-SA',
  [LayoutLang.En]: 'en-US',
};
